export type Dict<V, K extends string = string> = Record<K, V>;

export function toDict<Value, Key extends string = string>(arr: [Key, Value][]): Dict<Value, Key> {
  const result = {} as Dict<Value, Key>;
  arr.forEach(([key, value]) => {
    result[key] = value;
  });
  return result;
}

export function dictToList<Value, Key extends string = string>(dict: Dict<Value, Key>): [Key, Value][] {
  return Object.entries(dict) as [Key, Value][];
}

export function filterDict<Value, Key extends string = string>(dict: Dict<Value, Key>, fn: (key: Key, value: Value) => boolean): Dict<Value, Key> {
  return toDict(
    dictToList(dict).filter(([key, value]) => {
      return fn(key, value);
    }),
  );
}

export function mapValues<OldValue, NewValue, Key extends string = string>(dict: Dict<OldValue, Key>, callback: (value: OldValue) => NewValue): Dict<NewValue, Key> {
  return toDict(
    dictToList(dict).map(([key, value]): [Key, NewValue] => {
      return [key, callback(value)];
    }),
  );
}
